
import { forceNextTick } from "@/util/force-next-tick";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class Copyable extends Vue {
  @Prop({ default: true })
  shouldCopy!: boolean;

  mounted() {
    if (!this.shouldCopy) return;

    forceNextTick(() => {
      // @ts-ignore
      this.$refs.input.select();
      document.execCommand("copy");
    });
  }
  get textToCopy() {
    // @ts-ignore
    return this.$slots?.default[0]?.text || "";
  }

  copy() {
    // @ts-ignore
    this.$refs.input.select();
    document.execCommand("copy");
    this.$emit("onCopy");
  }
}
